import { Component, OnInit } from '@angular/core';
import {JobListingService} from './job-listing.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-job-listing',
  templateUrl: './job-listing.component.html',
  styleUrls: ['./job-listing.component.css']
})
export class JobListingComponent implements OnInit {

  private departmentId: bigint;
  public vacancies: any;
  public jobTypes: any;
  public jobTypess: any;
  private ids = [];
  private names = [];
  private stateChanges = [];
  private stateList = [];

  public showVacancy = false;

  constructor(private jobListingService: JobListingService,
              private route: ActivatedRoute
              ) { }

  ngOnInit(): void {
    this.departmentId = this.route.snapshot.params.departmentId;
    this.getDepartmentVacancies();
    this.getJobTypes();
  }


  getDepartmentVacancies(){
    return this.jobListingService.getDepartmentVacancies(this.departmentId)
      .subscribe(response => {
        this.vacancies = response;
        this.isVacancyPresent(this.vacancies.length)
        console.log('Vacancies', this.vacancies);
      });
  }

  getJobTypes(){
    return this.jobListingService.getJobTypes()
      .subscribe(response => {
        this.jobTypes = response;

        for (let keyy of this.jobTypes) {
          let typeOfJob = keyy

          this.ids.push(typeOfJob['id']);
          this.names.push(typeOfJob['name']);
          this.stateChanges.push("off");
        }

      });
  }

  
  genericSearch(data){
    return this.jobListingService.genericSearch(data['searchValue'])
      .subscribe(response => {
        this.vacancies = response;
        this.isVacancyPresent(this.vacancies.length)
        console.log('=============== search results >> ', this.vacancies);
      });
  }

  onChange(data, id){

    let i : number;    
    this.stateList = [];

    for(i=0; i<this.ids.length; i++){

      if(id === this.ids[i] )       
        this.stateChanges[i] = data;
      
      if( "on".match(this.stateChanges[i]))
        this.stateList.push(this.names[i])       
    }

    return this.jobListingService.searchByJobType(this.stateList)
    .subscribe(response => {
      this.vacancies = response;
      this.isVacancyPresent(this.vacancies.length)
      console.log('=============== search results >> ', this.vacancies);
    });

  }

  isVacancyPresent(vacancyArraySize){
    if(vacancyArraySize === 0){
      this.showVacancy = false;
    }else{
      this.showVacancy = true;
    }
  }

}
